import { JSONSchemaType } from 'ajv'
import validationPatters from 'schema/patterns'

export interface IResetPasswordFormData {
  password: string
  password_confirmation: string
}

const ResetPasswordSchema: JSONSchemaType<IResetPasswordFormData> = {
  type: 'object',
  properties: {
    password: {
      type: 'string',
      minLength: 8,
      pattern: validationPatters.password,
    },
    password_confirmation: {
      type: 'string',
    },
  },
  required: ['password', 'password_confirmation'],
  additionalProperties: false,
  allOf: [
    {
      properties: {
        confirmPassword: {
          const: { $data: '1/password' },
          errorMessage: 'Senhas devem ser idênticas',
        },
      },
    },
  ],
}

export default ResetPasswordSchema
